import { render, staticRenderFns } from "./VoluntaryPaymentsPeriodSelectors.vue?vue&type=template&id=d12d4caa"
import script from "./VoluntaryPaymentsPeriodSelectors.vue?vue&type=script&lang=js"
export * from "./VoluntaryPaymentsPeriodSelectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports